import { render, staticRenderFns } from "./chat-box-v2.vue?vue&type=template&id=9d106446&scoped=true"
import script from "./chat-box-v2.vue?vue&type=script&lang=js"
export * from "./chat-box-v2.vue?vue&type=script&lang=js"
import style0 from "./chat-box-v2.vue?vue&type=style&index=0&id=9d106446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d106446",
  null
  
)

export default component.exports